/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

// You can delete this file if you're not using it
import "./src/styles/global.css"

export const onServiceWorkerUpdateReady = () => {
  const answer = window.confirm(
    `This application has been updated. ` +
      `Reload to display the latest version?`
  )

  if (answer === true) {
    window.location.reload()
  }
}

export const onClientEntry = () => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.onerror = function (message, source, lineno, colno, error) {
      const currentPageUrl = window.location.href;
      const currentPagePath = window.location.pathname;

	  if(message.toLowerCase().includes("minified react error")) {
	    return true;
	  }
	  
      window.gtag('event', 'javascript_error', { // Create a custom event called 'javascript_error'
        event_category: 'Error',
        event_action: 'Client Side Error',
        error_message: message,
        error_source: source,
        error_line: lineno,
        error_column: colno,
        error_stack: error ? error.stack : 'N/A', // Capture the stack trace if available
        page_url: currentPageUrl,
        page_path: currentPagePath,
      });

      console.error("Client-side error caught by window.onerror:", {
        message,
        source,
        lineno,
        colno,
        error,
        currentPageUrl,
        currentPagePath,
      });
      // Optionally return true to suppress the default browser error logging
      return true; 
    };

    window.onunhandledrejection = function (event) {
      const currentPageUrl = window.location.href;
      const currentPagePath = window.location.pathname;

      window.gtag('event', 'promise_rejection', { // Create a custom event called 'promise_rejection'
        event_category: 'Error',
        event_action: 'Unhandled Promise Rejection',
        error_reason: event.reason ? event.reason.toString() : 'Unknown Reason',
        page_url: currentPageUrl,
        page_path: currentPagePath,
      });

      console.error("Unhandled Promise Rejection caught by window.onunhandledrejection:", {
        reason: event.reason,
        currentPageUrl,
        currentPagePath,
      });
      event.preventDefault(); // Prevent default console logging
    };
  }
};